import { computed, ref } from 'vue';
import http, { imageUrl, fileUrl, uploadUrl } from './http';

export default function () {
    const loading = ref(true);
    const info = ref();
    const rencentList = ref();
    const form = ref({
        pageIndex: 1,
        pageSize: 20,
        sortConditions: [
            {
                "sortField": "id",
                "listSortDirection": 1
            }
        ]
    });
    const list = ref();
    const total = ref(0);
    const pages = computed(() => {
        const totalItems = total.value;
        const size = form.value.pageSize;
        if (!size || size <= 0) return 1;
        return Math.ceil(totalItems / size);
    });

    const onPageChange = (page) => {
        form.value.pageIndex = page;
        readPage();
    };

    function readPage() {
        loading.value = true;
        http.request("post", "/api/app/blog/readpage", form.value).then(data => {
            list.value = data.Rows;
            total.value = data.Total;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).finally(() => {
            loading.value = false;
        });
    }

    function read(id) {
        loading.value = true;
        http.request("get", "/api/app/blog/read", { id }).then(res => {
            if (res?.Type == 200) {
                info.value = res?.Data
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function readRecent(count) {
        loading.value = true;
        http.request("get", "/api/app/blog/readrecent", { count }).then(res => {
            if (res?.Type == 200) {
                rencentList.value = res?.Data
            }
        }).finally(() => {
            loading.value = false;
        });
    }


    return {
        loading,
        form,
        info,
        rencentList,
        list,
        total,
        pages,
        onPageChange,
        readPage,
        readRecent,
        read
    }
}